module.exports = __webpack_public_path__ + "img/company.4e28b35d.svg";